/** `32.7` -> `32,7`, `50` -> `50`. Trailing zeros of the decimals are dropped. */
export const formatLiters = (value: number) =>
  String(Number(value.toFixed(2))).replace('.', ',')

/**
 * `Количество` is Decimal(15,2), so what the manager typed is snapped to two
 * decimals before it is validated and sent — the summary then shows exactly
 * the figure the station is asked for.
 */
export const roundLiters = (value: number) => Number(value.toFixed(2))

/**
 * Floors to the two decimals `Количество` accepts. Rounding would be wrong —
 * every caller is a ceiling the account must not be pushed past, so the figure
 * may only ever move down.
 *
 * The `toFixed(6)` is what keeps the floor honest: `12.35 * 100` is
 * `1234.9999999999998` in binary floating point, and flooring that raw would
 * quietly withhold a hundredth of a litre the account actually holds. Snapping
 * the scaled value to six decimals erases the representation error while
 * leaving anything genuinely below the cent-litre — `1234.9` — untouched.
 */
export const floorLiters = (value: number) =>
  Math.floor(Number((value * 100).toFixed(6))) / 100

/** Parses what the user typed, accepting both `12,5` and `12.5`. */
export const parseAmount = (value: string) => {
  const parsed = Number(String(value).replace(',', '.').trim())
  return Number.isFinite(parsed) ? parsed : 0
}
